// Settings the container decides, not the build.
//
// The support contact differs between dev and production; baking it into the
// bundle would mean a rebuild to change it.
type RuntimeConfig = {
  VITE_SUPPORT_TELEGRAM_URL?: string;
};

declare global {
  interface Window {
    __IMAGINAI_PORTAL_CONFIG__?: RuntimeConfig;
  }
}

const buildConfig: RuntimeConfig = {
  VITE_SUPPORT_TELEGRAM_URL: import.meta.env.VITE_SUPPORT_TELEGRAM_URL,
};

export function readRuntimeConfigValue(key: keyof RuntimeConfig, fallback = ''): string {
  const runtime = typeof window === 'undefined' ? undefined : window.__IMAGINAI_PORTAL_CONFIG__;
  const value = String(runtime?.[key] ?? buildConfig[key] ?? '').trim();
  return value || fallback;
}
